import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { DeliveryTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-delivery-type-container',
  templateUrl: './delivery-type-container.component.html',
  styleUrls: ['./delivery-type-container.component.scss']
})
export class DeliveryTypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  deliverytypes$: Observable<DeliveryTypeDto[]>;
  loading: boolean;
  isLoadingDeliveryType$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingDeliveryType$ = this.gatwayFacade.isLoadingGateway("DeliveryType");
    this.deliverytypes$ = this.gatwayFacade.loadGateway("DeliveryType");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDeliveryType(deletedValue: any) {
    this.gatwayFacade.remove("DeliveryType", deletedValue);
  }


// this method control both the create and update

  onSubmitDeliveryType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.DeliveryTypes;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllDeliveryType = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllDeliveryType.push(pullData[i]);
    }
  }

// check if the addAllDeliveryType array is not empty, then dispatch the data to the store
   if(addAllDeliveryType.length > 0) {
    this.gatwayFacade.add('DeliveryType', addAllDeliveryType);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('DeliveryType', allUpdates, ['id']);
  }

   }
}
